import QuickView from 'components/quickView';
import { DefaultQuickViewHeader } from 'components/quickView/components/DefaultQuickViewComponents/Header';
import AbsoluteQuickViewHeader from 'components/quickView/components/QuickViewWithAbsoluteHeader/Header';
import useCloseVariantPickerQuickview from './shared/hooks/useCloseVariantPickerQuickview';
import useVariantPickerQuickView from './shared/hooks/useVariantPickerQuickView';
import VariantPicker from './VariantPicker';

export default function VariantPickerQuickView() {
    const [{ isOpen, variantPickerModel, isPDPRequest }] = useVariantPickerQuickView();
    const closeVariantPickerQuickview = useCloseVariantPickerQuickview();

    if (!variantPickerModel) return null;

    const { image } = variantPickerModel;

    return (
        <QuickView.Controlled
            lockScroll
            active={isOpen}
            onClose={closeVariantPickerQuickview}
            headerRenderer={() =>
                image ? (
                    <AbsoluteQuickViewHeader userCanClose onClose={closeVariantPickerQuickview} />
                ) : (
                    <DefaultQuickViewHeader userCanClose onClose={closeVariantPickerQuickview} />
                )
            }
            position="right"
        >
            <VariantPicker model={variantPickerModel} isPDPRequest={isPDPRequest} />
        </QuickView.Controlled>
    );
}
